module.exports = __webpack_public_path__ + "static/media/artiso.4ba7cbc8.svg";